var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['miniliink', { inApp: _vm.$root.$data.isApp || this.$root.miniprogram }]},[_c('div',{staticClass:"miniliink-box"},[_c('img',{staticClass:"pxind",attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/choose_skip.png","alt":""}}),_c('button',{on:{"click":_vm.goSkip}},[_vm._v("点击立即定制")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }